/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
import DataTables from 'pages/invite-codes';

import Accounts from 'pages/accounts/accounts';
import NewAccount from 'pages/new-account';
import NewInviteCode from 'pages/new-invite-code';
import SignInBasic from 'pages/sign-in/sign-in';
import SignUpBasic from 'pages/sign-up/sign-up';
import AuthRequired from 'pages/auth-required';
import NotFound from 'pages/not-found';

// Material Dashboard 2 PRO React TS components
import MDAvatar from 'components/MDAvatar';

// @mui icons
import Icon from '@mui/material/Icon';

// Images
import profilePicture from 'assets/images/team-3.jpg';
import Sales from 'pages/dashboard';
import Settings from 'pages/settings';
import Credits from 'pages/credits';
import TopUp from 'pages/top-up';
import LogoutHandler from 'components/LogoutHandler';

const routes = [
  {
    type: 'collapse',
    name: 'Brooklyn Alice',
    key: 'brooklyn-alice',
    icon: <MDAvatar src={profilePicture} alt="Brooklyn Alice" size="sm" />,
    collapse: [
      {
        name: 'Settings',
        key: 'profile-settings',
        route: '/account/settings',
        component: <Settings />,
        requiresAuth: true,
      },
      {
        name: 'Logout',
        key: 'logout',
        route: '/logout',
        component: <LogoutHandler />,
        requiresAuth: false,
      },
    ],
  },
  { type: 'divider', key: 'divider-0' },
  {
    type: 'collapse',
    name: 'Home',
    key: 'home',
    icon: <Icon fontSize="medium">dashboard</Icon>,
    component: <Sales />,
    route: '/home',
    noCollapse: true,
    requiresAuth: true,
  },
  {
    type: 'collapse',
    name: 'Accounts',
    key: 'accounts',
    icon: <Icon fontSize="medium">account_circle</Icon>,
    component: <Accounts />,
    route: '/accounts',
    noCollapse: true,
    requiresAuth: true,
  },
  // {
  //   type: 'collapse',
  //   name: 'Invite codes',
  //   key: 'invite_codes',
  //   icon: <Icon fontSize="medium">person_add</Icon>,
  //   component: <DataTables />,
  //   route: '/invite-codes',
  //   noCollapse: true,
  //   requiresAuth: true,
  // },
  {
    type: 'collapse',
    name: 'Credits',
    key: 'credits',
    icon: <Icon fontSize="medium">paid</Icon>,
    component: <Credits />,
    route: '/credits',
    noCollapse: true,
    requiresAuth: true,
  },
  {
    type: 'collapse',
    name: 'Top Up',
    key: 'top-up',
    icon: <Icon fontSize="medium">account_balance_wallet</Icon>,
    component: <TopUp />,
    route: '/top-up',
    noCollapse: true,
    requiresAuth: true,
  },
  {
    type: 'title',
    name: 'New User',
    key: 'new-account',
    route: '/accounts/new-account',
    component: <NewAccount />,
    requiresAuth: true,
  },
  // {
  //   type: 'title',
  //   name: 'New Invite Code',
  //   key: 'new-invite-code',
  //   route: '/invite-codes/new-invite-code',
  //   component: <NewInviteCode />,
  //   requiresAuth: true,
  // },
  {
    name: 'Sign In',
    key: 'sign-in',
    route: '/sign-in',
    component: <SignInBasic />,
    requiresAuth: false,
  },
  {
    name: 'Sign up',
    key: 'sign-up',
    route: '/sign-up',
    component: <SignUpBasic />,
    requiresAuth: false,
  },
  {
    name: 'Auth Required',
    key: 'auth-required',
    route: '/auth-required',
    component: <AuthRequired />,
    requiresAuth: false,
  },
  {
    name: 'Not Found',
    key: 'not-found',
    route: '/not-found',
    component: <NotFound />,
    requiresAuth: false,
  },
];

export default routes;
